import React from "react";

const statusLabels = {
  in_process: "In Process",
  won: "Won",
  lost: "Lost",
};

const forecastLabels = {
  pipeline: "Pipeline",
  best_case: "Best Case",
  committed: "Committed",
  omitted: "Omitted",
};

const formatAmount = (amount, currency = "USD") =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
  }).format(amount || 0);

const formatDate = (value) =>
  value ? new Date(value).toLocaleDateString() : "—";

const DetailItem = ({ label, value }) => (
  <div className="flex min-h-16 flex-col gap-1 rounded-lg bg-gray-50 p-3">
    <span className="text-xs text-gray-500">{label}</span>
    <span className="break-words text-sm font-medium text-gray-900">
      {value || value === 0 ? value : "—"}
    </span>
  </div>
);

const DealOverview = ({ deal }) => (
  <section className="w-full rounded-[12px] border font-sans">
    <h2 className="border-b p-4 text-[14px] font-medium text-gray-800">
      Deal Information
    </h2>
    <div className="grid grid-cols-1 gap-3 p-4 sm:grid-cols-2 lg:grid-cols-3">
      <DetailItem label="Deal Name" value={deal.name} />
      <DetailItem
        label="Deal Amount"
        value={formatAmount(deal.amount, deal.currency)}
      />
      <DetailItem label="Associated Company" value={deal.companyName} />
      <DetailItem
        label="Stage / Status"
        value={statusLabels[deal.status] || deal.status}
      />
      <DetailItem label="Pipeline Category" value={deal.pipeline} />
      <DetailItem label="Deal Type" value={deal.dealType} />
      <DetailItem label="Owner" value={deal.owner?.name} />
      <DetailItem label="Contact Name" value={deal.contactName} />
      <DetailItem label="Next Step" value={deal.nextStep} />
      <DetailItem label="Lead Source" value={deal.leadSource} />
      <DetailItem label="Campaign Source" value={deal.campaignSource} />
      <DetailItem label="Social Lead ID" value={deal.socialLeadId} />
      <DetailItem label="Currency" value={deal.currency} />
      <DetailItem label="Probability" value={`${deal.probability ?? 0}%`} />
      <DetailItem
        label="Expected Revenue"
        value={formatAmount(deal.expectedRevenue, deal.currency)}
      />
      <DetailItem label="Industry" value={deal.industry} />
      <DetailItem label="Company Size" value={deal.companySize} />
      <DetailItem
        label="Forecast Category"
        value={forecastLabels[deal.forecastCategory] || deal.forecastCategory}
      />
      <DetailItem
        label="Estimated Closing Date"
        value={formatDate(deal.estimatedCloseDate)}
      />
      <DetailItem label="Created Date" value={formatDate(deal.createdDate)} />
      <DetailItem label="Last Updated" value={formatDate(deal.updatedAt)} />
    </div>
  </section>
);

export default DealOverview;
